import React from 'react'
import ReactMarkdown from 'react-markdown'
import { injectIntl, intlShape } from 'react-intl'

import './ContentBlocks.css'

const FullbleedContentBlock = (props) => (
  <div className={'fullbleed content-block '+props.align}>
    <div className="container">
      {props.align!=='center' && <div style={props.fields.image?{backgroundImage: 'url('+props.fields.image[0].fields.file.url+'?fm=jpg&q=80)'}:{}} />}
      <div>
        {props.fields.topHeading && <div className="subheading">{props.fields.topHeading}</div>}
        {props.fields.heading && <h2>{props.fields.heading}</h2>}
        
        {props.fields.lead && <div className="lead">
          <ReactMarkdown source={props.fields.lead} softBreak="br" />
        </div>}

        {props.fields.content && <div className="content">
          <ReactMarkdown source={props.fields.content} softBreak="br" />
        </div>}

        {(props.fields.leadLinkText && (props.fields.leadInternalLink || props.fields.leadLinkUrl)) && <a href={props.fields.leadInternalLink ? props.fields.leadInternalLink.fields.slug : props.fields.leadLinkUrl} className="btn">{props.fields.leadLinkText}</a>}
      </div>
    </div>
  </div>
)

FullbleedContentBlock.propTypes = {
  intl: intlShape.isRequired,
}

export default injectIntl(FullbleedContentBlock)



// WEBPACK FOOTER //
// ./src/components/ContentBlocks/FullbleedContentBlock.js